/** Человекочитаемые названия аудио-провайдеров голосов. */
export const VOICE_PROVIDER_LABELS: Record<string, string> = {
  elevenlabs: "ElevenLabs",
  minimax: "MiniMax",
}

export function voiceProviderLabel(kind: string): string {
  return VOICE_PROVIDER_LABELS[kind] ?? kind
}
